import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { Team } from '../types';
import { mediaUrl } from '../utils/mediaUrl';

const SPORT_ICONS: Record<string, string> = { soccer: '⚽', baseball: '⚾', softball: '🥎', basketball: '🏀' };

const Teams = () => {
  const [teams, setTeams] = useState<Team[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/teams').then(r => setTeams(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="container" style={{ paddingTop: 8 }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 32, fontWeight: 900, letterSpacing: '-0.5px', color: 'var(--ink-1)', marginBottom: 4 }}>Teams</h1>
        <p style={{ color: 'var(--ink-3)', fontSize: 14 }}>Rosters, schedules, and game archives.</p>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px', color: 'var(--ink-4)' }}>Loading...</div>
      ) : teams.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: '80px 20px' }}>
          <i className="ti ti-trophy" style={{ fontSize: 48, color: 'var(--ink-4)', display: 'block', marginBottom: 16 }} />
          <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 8, color: 'var(--ink-1)' }}>No teams yet</h3>
          <p style={{ color: 'var(--ink-3)', fontSize: 14 }}>An admin can create teams from the Admin panel.</p>
        </div>
      ) : (
        <div className="games-grid">
          {teams.map(team => (
            <Link
              key={team.id}
              to={`/teams/${team.id}`}
              style={{ textDecoration: 'none' }}
            >
              <div style={{
                background: 'var(--surface)', border: '1px solid var(--hairline)', borderRadius: 12,
                padding: 20, cursor: 'pointer', transition: 'border-color 0.15s, transform 0.1s, box-shadow 0.15s',
                overflow: 'hidden', position: 'relative',
              }}
                onMouseEnter={e => {
                  const el = e.currentTarget as HTMLElement;
                  el.style.borderColor = 'var(--hairline-strong)';
                  el.style.transform = 'translateY(-2px)';
                  el.style.boxShadow = '0 8px 24px rgba(0,0,0,0.09)';
                }}
                onMouseLeave={e => {
                  const el = e.currentTarget as HTMLElement;
                  el.style.borderColor = 'var(--hairline)';
                  el.style.transform = 'translateY(0)';
                  el.style.boxShadow = 'none';
                }}
              >
                {/* Team color top bar */}
                <div style={{
                  position: 'absolute', top: 0, left: 0, right: 0, height: 4,
                  background: `linear-gradient(to right, ${team.primary_color || '#0F2748'}, ${team.secondary_color || '#FFC72C'})`,
                }} />

                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12, marginTop: 8 }}>
                  <div style={{
                    width: 52, height: 52, borderRadius: 10, flexShrink: 0,
                    background: team.logo_url ? 'transparent' : (team.primary_color || 'var(--team-primary)'),
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 24, overflow: 'hidden', border: '1px solid var(--hairline)',
                  }}>
                    {team.logo_url
                      ? <img src={mediaUrl(team.logo_url)} alt={team.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      : SPORT_ICONS[team.sport] || '🏆'}
                  </div>
                  <div>
                    <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 17, color: 'var(--ink-1)', marginBottom: 2 }}>{team.name}</div>
                    <div style={{ fontSize: 12, color: 'var(--ink-3)' }}>
                      {SPORT_ICONS[team.sport]} {team.sport.charAt(0).toUpperCase() + team.sport.slice(1)} · {team.season_year}
                    </div>
                  </div>
                </div>

                {team.description && (
                  <p style={{ fontSize: 13, color: 'var(--ink-3)', lineHeight: 1.5, marginBottom: 10 }}>{team.description}</p>
                )}

                <div style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
                  color: team.primary_color || 'var(--sr-teal)', fontSize: 13, fontWeight: 700,
                }}>
                  View team <i className="ti ti-arrow-right" style={{ fontSize: 13, marginLeft: 4 }} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Teams;
